import { render, staticRenderFns } from "./IntegerElement.vue?vue&type=template&id=4cc81cc9&scoped=true&"
import script from "./IntegerElement.vue?vue&type=script&lang=js&"
export * from "./IntegerElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc81cc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc81cc9')) {
      api.createRecord('4cc81cc9', component.options)
    } else {
      api.reload('4cc81cc9', component.options)
    }
    module.hot.accept("./IntegerElement.vue?vue&type=template&id=4cc81cc9&scoped=true&", function () {
      api.rerender('4cc81cc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Elements/IntegerElement.vue"
export default component.exports